import { ISeasonResponse, ISport } from "src/services";

export const filterSportsBySeason = ({
  seasonName,
  seasons,
  sports,
}: {
  seasonName: string;
  seasons: ISeasonResponse[];
  sports: ISport[];
}) => {
  const selectedSeason = seasons.find((season) => season.name === seasonName);

  if (selectedSeason === undefined) {
    return sports;
  }

  return sports.filter((sport) => {
    return (
      selectedSeason.sportIds.find((sportId) => sportId === sport.id) !==
      undefined
    );
  });
};



// WEBPACK FOOTER //
// ./src/pages/director/dashboard/utils/filter-sports-by-season/filterSportsBySeason.ts